import {onglets} from "@/class/onglets/onglets";
import history from "@/class/history";
import onglet from "@/class/onglets/onglet";
import {volets} from "@/class/volets";
import {baseModel, baseModelLink} from "@/class/baseModel";
import {link} from "@/class/link";
import nav from "@/class/nav/nav";

export class viewModel extends baseModel{
    
    name = "";
    
    volets = new volets();
    history = new history();
    
    
    getName(){
        return this.name;
    }
    getThumbnail(){
        return "";
    }
    
    // HELPERS
    /**
     * Gestion des onglets
     */
    
    ongletSet(){
        // this.onglet = new ongletClass().setData({
        //     storieId: this.getStoryId(),
        //     router: this.getRoute(),
        //     pk: this.getId(),
        //     title: this.getName(),
        //     thumbnail: this.getThumbnail(),
        //     type: this.objectType,
        //     closable: true,
        //     active: false,
        //     save: true,
        // });
        // console.log(this.onglet)
    }
    
    // ongletAdd(){
    //     this.onglet.active = true;
    //     onglets.add(this.onglet);
    // }
    // ongletGet(){
    //     return this.onglet;
    // }
    ongletClose(onglet=null){
        nav.closeByObject(this)
    }
    
    /**
     * Gestion de l'historique
     */

    // history
    historyAdd(){
        this.history.add(this.getDataReq());
    
    }
    historyClear(){
        this.history.clear();
    }
    historyUndo(){
        
        if(!this.historyUndoIsActive()){
            return false;
        }
        
        this.setDataReq(this.history.undo());
        
        return true;
    }
    historyRedo(){
        
        if(!this.historyRedoIsActive()) {
            return false;
        }
        
        this.setDataReq(this.history.redo());
        
        return true;
    }
    historyUndoIsActive(){
        return this.history.current > 0;
    }
    historyRedoIsActive(){
        // console.log("Current : "+this.history.current+" | length : "+this.history.length())
        return this.history.current < this.history.length() - 1 ;
    }
    
}


export class viewModelLink extends viewModel{

    link = new link();

    getDataReq() {

        let data = super.getDataReq();

        return {...data, ...this.link.getDataReq()}
    }

    setDataReq(data, preview = false) {

        super.setDataReq(data, preview);

        this.link.load(data)

    }

    toReq(){
        let data = super.toReq()

        data = {...data, ...this.link.toReq()}

        return data;
    }
}
